import { AixCommandItem, commandBarIconCn, commandBarOpenAtom, CommandGroup, CommandSeparator } from "@aix/ui"
import { useNavigate } from "@tanstack/react-router"
import { useAtom } from "jotai"

import { getNavigationForUser } from "../../config/navigationConfig"
import { useAuth } from "../../lib/auth-context"
import { trpc } from "../../lib/trpc"

export const NavigationCommandItems = () => {
  const [, setCommandBarOpen] = useAtom(commandBarOpenAtom)
  const navigate = useNavigate()
  const { user } = useAuth()

  // Get user access information
  const { data: userAccessData } = trpc.accessControl.getUserCategoryAccess.useQuery(undefined, {
    enabled: !!user,
  })

  const userCategories = userAccessData?.success ? userAccessData.access.categories : []
  const isSuperAdmin = userAccessData?.success ? userAccessData.user.isSuperAdmin : false

  const { categories, systemItems } = getNavigationForUser(userCategories, isSuperAdmin)

  const handleNavigate = async (to: string) => {
    await navigate({ to })
    setCommandBarOpen(false)
  }

  const handleNavigateNewTab = (to: string) => {
    window.open(window.location.origin + to, "_blank")
    setCommandBarOpen(false)
  }

  if (!userAccessData) {
    return null
  }

  // Flatten all navigation items, including subitems
  const allNavigationItems = [
    ...systemItems,
    ...categories.flatMap((category) =>
      category.items.flatMap((item) => {
        // If item has subItems, return the subItems instead
        if ("subItems" in item && item.subItems) {
          return item.subItems
        }
        // Otherwise return the item itself
        return [item]
      }),
    ),
  ]

  return (
    <>
      <CommandSeparator />
      <CommandGroup heading="Navigate">
        {allNavigationItems.map((item) => {
          // Extract emoji from label for icon
          const displayLabel = item.label
          const icon = item.icon

          return (
            <AixCommandItem
              key={item.to}
              onSelect={() => handleNavigate(item.to)}
              name={displayLabel}
              icon={<span className={commandBarIconCn}>{icon}</span>}
            />
          )
        })}
      </CommandGroup>
    </>
  )
}
